<template>
  <v-dialog v-model="internalValue" :max-width="maxWidth" persistent>
    <v-card class="v-card-100 mt-0">
      <!-- Header -->
      <v-card class="v-card-100 custom-shadow ma-0 p-2">
        <v-card-title class="d-flex align-center pa-0">
          <span class="font-weight-bold">{{ title }}</span>
          <v-spacer></v-spacer>
          <v-icon @click="closeDialog">mdi-close</v-icon>
        </v-card-title>
      </v-card>

      <!-- Custom Body -->
      <v-card-text class="pa-6">
        <slot name="body"></slot>
      </v-card-text>

      <!-- Footer Buttons -->
      <v-card-actions v-if="showActions">
        <v-spacer></v-spacer>
        <v-btn
          v-if="showCancel"
          variant="outlined"
          class="mb-3 text-none"
          color="primary"
          size="large"
          @click="handleCancel"
        >
          {{ cancelText }}
        </v-btn>
        <v-btn
          v-if="showSubmit"
          class="mb-3 text-none"
          :color="submitColor"
          size="large"
          variant="flat"
          @click="handleSubmit"
          :disabled="submitDisabled"
        >
          {{ submitText }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CommonDialog",
  props: {
    modelValue: Boolean,
    title: {
      type: String,
      default: "Dialog Title",
    },
    maxWidth: {
      type: [String, Number],
      default: "500px",
    },
    showActions: {
      type: Boolean,
      default: true,
    },
    showCancel: {
      type: Boolean,
      default: true,
    },
    showSubmit: {
      type: Boolean,
      default: true,
    },
    cancelText: {
      type: String,
      default: "Cancel",
    },
    submitText: {
      type: String,
      default: "Submit",
    },
    submitColor: {
      type: String,
      default: "#003C9E",
    },
    submitDisabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
  methods: {
    closeDialog() {
      this.internalValue = false;
    },
    handleCancel() {
      this.$emit("cancel");
      this.closeDialog();
    },
    handleSubmit() {
      this.$emit("submit");
    },
  },
};
</script>

